<button *ngIf="disponible" type="button" class="btn btn-outline-primary btn-sm"
        title="{{t.busquedaavanzada}}"
        (click)="abrir(plantilla)">
  <i class="bi bi-search mr-1"></i>{{t.busquedaavanzada}}
</button>

<ng-template #plantilla>
  <div class="modal-header">
    <h5 class="modal-title">{{t.busquedaavanzada}}</h5>
    <button type="button" class="close" aria-label="Close" (click)="cerrar()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body busqueda-avanzada-cuerpo">

    <div class="row">
      <div class="col-12 col-md-6 col-lg-4 mb-2" *ngFor="let campo of campos">
        <label class="busqueda-avanzada-label mb-1" [attr.for]="'ba-' + campo.control">
          {{campo.etiqueta}}
        </label>
        <ng-container [ngSwitch]="campo.tipo">

          <select *ngSwitchCase="'booleano'" class="form-control form-control-sm"
                  [id]="'ba-' + campo.control"
                  [(ngModel)]="valores[campo.control]"
                  [ngModelOptions]="{standalone: true}">
            <option value="">{{t.todos}}</option>
            <option [value]="t.si">{{t.si}}</option>
            <option [value]="t.no">{{t.no}}</option>
          </select>

          <input *ngSwitchCase="'fecha'" type="date" class="form-control form-control-sm"
                 [id]="'ba-' + campo.control"
                 [(ngModel)]="valores[campo.control]"
                 [ngModelOptions]="{standalone: true}"
                 (keyup.enter)="onBuscar()">

          <input *ngSwitchCase="'numero'" type="number" step="any"
                 class="form-control form-control-sm"
                 [id]="'ba-' + campo.control"
                 [(ngModel)]="valores[campo.control]"
                 [ngModelOptions]="{standalone: true}"
                 (wheel)="soltarFoco($event)"
                 (keyup.enter)="onBuscar()">

          <input *ngSwitchDefault type="text" class="form-control form-control-sm"
                 [id]="'ba-' + campo.control"
                 [(ngModel)]="valores[campo.control]"
                 [ngModelOptions]="{standalone: true}"
                 (keyup.enter)="onBuscar()">

        </ng-container>
      </div>
    </div>

    <hr>

    <div class="row">
      <div class="col-12 col-md-6 col-lg-4 mb-2">
        <label class="busqueda-avanzada-label mb-1">{{t.ordenarpor}}</label>
        <select class="form-control form-control-sm"
                [(ngModel)]="campoOrden"
                [ngModelOptions]="{standalone: true}">
          <option [ngValue]="undefined" disabled>{{t.seleccionecolumna}}</option>
          <option *ngFor="let columna of columnas" [ngValue]="columna.campo">{{columna.etiqueta}}</option>
        </select>
      </div>

      <div class="col-12 col-md-6 col-lg-4 mb-2">
        <label class="busqueda-avanzada-label mb-1">{{t.direccionorden}}</label>
        <select class="form-control form-control-sm"
                [(ngModel)]="direccionOrden"
                [ngModelOptions]="{standalone: true}">
          <option value="asc">{{t.ascendente}}</option>
          <option value="desc">{{t.descendente}}</option>
        </select>
      </div>
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-sm"
            [disabled]="!hayAlgoCargado" (click)="onLimpiar()">{{t.limpiar}}</button>
    <button type="button" class="btn btn-secondary btn-sm" (click)="cerrar()">{{t.cancelar}}</button>
    <button type="button" class="btn btn-primary btn-sm" (click)="onBuscar()">{{t.buscar}}</button>
  </div>
</ng-template>
